import { responseError } from '../../../core/Api/ResponseError';
import { NotFoundResponse } from '../../../server/response/NotFoundResponse';

export async function handleResponse<Data>(response: Response): Promise<Data> {
    if (response.status === 404) {
        throw NotFoundResponse.error(`404 Not Found from ${response.url}`);
    }

    if (response.status !== 200 && response.status !== 204) {
        throw await responseError(response);
    }

    if (response.status === 204) {
        return undefined as Data;
    }

    return response.json() as Promise<Data>;
}

export function catchNotFoundResource(error: unknown) {
    if (error instanceof NotFoundResponse.Error) {
        return undefined;
    }
    throw error;
}
